// extracted by mini-css-extract-plugin
export default {"field":"NameEdit_field__AALLv","fieldWrapper":"NameEdit_fieldWrapper__5BEQD","submitButton":"NameEdit_submitButton__37c+E"};